import { NgClass, NgFor, NgIf, NgOptimizedImage } from '@angular/common';
import {
  Component,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ISbRichtext, ISbStoriesParams } from '@storyblok/js';
import { DynamicModule } from 'ng-dynamic-component';
import { StoryblokRichTextDirective } from 'src/app/directive/storyblok-richtext.directive';
import { StoryblokDirective } from 'src/app/directive/storyblok.directive';
import { EnvironmentService } from 'src/app/service/environment.service';

@Component({
  selector: 'app-poster',
  imports: [
    RouterModule,
    DynamicModule,
    NgClass,
    NgIf,
    NgFor,
    StoryblokDirective,
    NgOptimizedImage,
    StoryblokRichTextDirective,
  ],
  templateUrl: './poster.component.html',
  styleUrl: './poster.component.scss',
})
export class PosterComponent implements OnInit, OnChanges {
  @Input() _editable: any;
  @Input() _uid!: string;
  @Input() component!: string;
  components: any;
  parseInt = parseInt;
  @Input() headline!: string;
  @Input() content!: ISbRichtext;
  @Input() image!: ISbStoriesParams;
  @Input() layout!: number;
  @Input() actions: any[] = [];
  @Input() accordions: any[] = [];
  @Input() eyebrow!: string;
  @Input() aspect_ratio: string = '7x10';
  @Input() offset_top: number = 0;
  @Input() offset_left: number = 0;
  @Input() offset_right: number = 0;
  @Input() offset_bottom: number = 0;
  @Input() padding_top: number = 0;
  @Input() y_borders: boolean = true;
  @Input() padding_bottom: number = 0;
  @Input() reverse_order: boolean = false;
  @Input() content_max_width: number | undefined = undefined;
  @Input() content_y: string = 'align-items-start';
  @Input() content_x: string = 'justify-content-start';
  @Input() hover_color: string = '';
  private elementTop!: number;
  private elementHeight!: number;
  private windowHeight!: number;

  width!: number;
  height!: number;
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private environmentService: EnvironmentService
  ) {
    import('src/app/storyblok/components').then((cp) => {
      this.components = cp.Components;
    });
  }

  ngOnInit(): void {
    if (this.aspect_ratio) {
      let sizes = this.aspect_ratio.split('x');
      this.width = parseInt(sizes[0]) * 100;
      this.height = parseInt(sizes[1]) * 100;
    } else {
      let sizes = '640x900'.split('x');
      this.width = parseInt(sizes[0]);
      this.height = parseInt(sizes[1]);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {}

  ngAfterViewInit() {
    if (!this.hover_color || !this.environmentService.isBrowser()) return;

    this.windowHeight = window.innerHeight;
    const elementRect = this.el.nativeElement.getBoundingClientRect();
    this.elementTop = elementRect.top + window.scrollY;
    this.elementHeight = elementRect.height;
  }

  @HostListener('window:scroll', [])
  onScroll() {
    const scrollPos = window.scrollY;
    const startFadeIn = this.elementTop - this.windowHeight;
    const endFadeIn = this.elementTop;
    const startFadeOut = this.elementTop;
    const endFadeOut = this.elementTop + this.elementHeight;

    let opacity = 0;

    if (scrollPos >= startFadeIn && scrollPos <= endFadeIn) {
      // Fade in as we scroll toward the element
      opacity = (scrollPos - startFadeIn) / (endFadeIn - startFadeIn);
    } else if (scrollPos > startFadeOut && scrollPos <= endFadeOut) {
      // Fade out as we scroll past the element
      opacity = 1 - (scrollPos - startFadeOut) / (endFadeOut - startFadeOut);
    } else if (scrollPos > endFadeOut) {
      // Reset opacity after scrolling away
      opacity = 0;
    } else if (scrollPos < startFadeIn) {
      // Before the element is in view
      opacity = 0;
    }
    let rgb = this.hexToRgb(this.hover_color);
    this.renderer.setStyle(
      this.el.nativeElement,
      'backgroundColor',
      `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})` // Adjust to your preferred color
    );
  }

  hexToRgb(hex: string): any {
    var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
      ? {
          r: parseInt(result[1], 16),
          g: parseInt(result[2], 16),
          b: parseInt(result[3], 16),
        }
      : this.hexToRgb('#D4D4C4');
  }
}
